var CryptoJS = require('crypto-js');
const KEY = '0D7FB71E8EC31E97';

export default {
    encrypt(data) {
        let str;
        if (typeof data === 'string') {
            str = data;
        } else {
            str = JSON.stringify(data);
        }
        var key = CryptoJS.enc.Utf8.parse(KEY);
        var ciphertext = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return ciphertext.toString();
    }
};
